<ng-content *ngIf="visible"></ng-content>

<div class="empty-list-container" *ngIf="!visible">
  {{ 'APP.TABLE.EMPTY_LIST' | translate }}
</div>
